
import { environment } from "../../../environments/environment";
import { horizontalSettings } from "./charts/horizontal/settings";
import { lineSettings } from "./charts/line/settings";
import { pieSettings } from "./charts/pie/settings";
import { verticalSettings } from "./charts/vertical/settings";
import { verticalLineSettings } from "./charts/vertical-line/settings";
import { donutSettings } from "./charts/donut/settings";
import { types } from "./helpers/types";

const environmentLink: string = environment().assetsLink;

export const chartSettings = () => {


    const defaultSettings: any = [
        {
            settingName: 'HorizontalAlignment',
        },
        {
            name: 'ChartType',
            title: 'Chart Type',
            isShowTitle: true,
            icon: environmentLink + '/assets/images/Charts/chart-type.svg',
            hasDrop: true,
            dropWidth: 'big',
            controls: [
                {
                    controlName: 'ImageSelect',
                    property: 'chartType',
                    grayscale: true,
                    grid: 4,
                    defaultValue: 'horizontal',
                    presetData:
                        types.map(type => ({
                            title: '',
                            icon: environmentLink + '/assets/images/Charts/Options/' + type.icon,
                            value: type.type,
                            width: 25,
                            tooltip: type.title
                        }))
                    ,
                    isCheckButton: true
                },
            ],
        },
        {
            settingName: 'ChartData',
            title: 'Edit Data',
            icon: environmentLink + '/assets/images/Options/edit-dark.svg',
            isShowTitle: false,
            hasDrop: true,
            dropWidth: 'popup',
            removePadding: true,
            controls: [
                {
                    controlName: 'ChartContent',
                    property: 'data',
                    title: 'Edit data'
                },
            ],
        },
        {
            settingName: 'Size',
            removePadding: true,
            dropWidth: 'big',
            controls: [
                {
                    controlName: 'Slider',
                    title: 'Size',
                    property: 'width',
                    defaultValue: 100,
                    suffix: '%',
                    min: 10,
                    separateLine: true,
                    padding: '16px'
                },
                {
                    controlName: 'ImageSelect',
                    property: 'height',
                    title: 'Height',
                    defaultValue: 'M',
                    padding: '0 16px 16px',
                    isValuesInsideBox: true,
                    useTitle: true,
                    presetData: [
                        {
                            title: 'XS',
                            value: 256,
                            width: 20
                        },
                        {
                            title: 'S',
                            value: 368,
                            width: 20
                        },
                        {
                            title: 'M',
                            value: 488,
                            width: 20
                        },
                        {
                            title: 'L',
                            value: 720,
                            width: 20
                        },
                        {
                            title: 'XL',
                            value: 960,
                            width: 20
                        }
                    ]
                }
            ],
        },
        {
            name: "TextColor",
            title: "Text Color",
            isShowTitle: true,
            icon: environmentLink + "/assets/images/Options/text.svg",
            iconType: 'color',
            iconProperty: 'textColor',
            hasDrop: true,
            dropWidth: 'big',
            removePadding: true,
            removeArrow: true,
            controls: [
                {
                    controlName: 'CustomColors',
                    property: 'color',
                    title: 'Text Color',
                    defaultValue: '#fff',
                },
            ],
        }
    ]
    const settings: { [ key: string ]: any } = {
        'horizontal': horizontalSettings(defaultSettings, environmentLink),
        'vertical': verticalSettings(defaultSettings, environmentLink),
        'line': lineSettings(defaultSettings, environmentLink),
        'pie': pieSettings(defaultSettings, environmentLink),
        'donut': donutSettings(defaultSettings, environmentLink),
        'vertical-line': verticalLineSettings(defaultSettings, environmentLink),
        'vertical-smooth-line': verticalLineSettings(defaultSettings, environmentLink),
        'horizontal-smooth-line': lineSettings(defaultSettings, environmentLink),
        'vertical-area': verticalLineSettings(defaultSettings, environmentLink),
        'horizontal-area': lineSettings(defaultSettings, environmentLink),
        'vertical-smooth-area': verticalLineSettings(defaultSettings, environmentLink),
        'horizontal-smooth-area': lineSettings(defaultSettings, environmentLink),
        'vertical-stacked': verticalSettings(defaultSettings, environmentLink),
        'horizontal-stacked': horizontalSettings(defaultSettings, environmentLink),
    }

    const labels: { [ key: string ]: string } = {
        'horizontal': 'Horizontal bar chart',
        'vertical': 'Vertical bar chart',
        'line': 'Horizontal line chart',
        'pie': 'Pie chart',
        'donut': 'Donut chart',
        'vertical-line': 'Vertical line chart',
        'vertical-smooth-line': 'Vertical smooth line chart',
        'horizontal-smooth-line': 'Horizontal smooth line chart',
        'vertical-area': 'Vertical area chart',
        'horizontal-area': 'Horizontal area chart',
        'vertical-stacked': 'Vertical stacked chart',
        'horizontal-stacked': 'Horizontal stacked chart',
        'horizontal-smooth-area': 'Horizontal smooth area chart',
        'vertical-smooth-area': 'Vertical smooth area chart',
    }

    return { settings, labels }
}